import type { StoreNavigationFooter } from '../../../types/footer';

export const mapCopyright = (config?: StoreNavigationFooter['config']) =>
  config?.pt_footer_copyright_text?.replace('{YEAR}', new Date().getFullYear().toString());
